import { createAction, props } from "@ngrx/store";

export const updateLoaderState = createAction(
  '[Global] Update Loader State',
  props<{ isLoading: boolean }>()
);